import { Injectable, Injector } from '@angular/core';
import { CtWorkspaceDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { BaseService } from '@common-modules/shared/base.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkspacesService extends BaseService {
  private _entityUrl: string;

  constructor(injector: Injector) {
    super(injector);
    this._entityUrl = `${this.apiUrl}/workspace`;
  }

  getWorkspacesByUserCode(): Observable<CtWorkspaceDto[]> {
    return this.httpCacheClient.get<CtWorkspaceDto[]>(`${this._entityUrl}`);
  }

  getWorkspaceById(workspaceId: string): Observable<CtWorkspaceDto> {
    return this.httpCacheClient.get<CtWorkspaceDto>(`${this._entityUrl}/${workspaceId}`);
  }

  createWorkspace(workspace: CtWorkspaceDto): Observable<CtWorkspaceDto> {
    return this.httpCacheClient.post<CtWorkspaceDto>(`${this._entityUrl}`, workspace);
  }

  updateWorkspace(workspace: CtWorkspaceDto): Observable<CtWorkspaceDto> {
    return this.httpCacheClient.put<CtWorkspaceDto>(`${this._entityUrl}`, workspace);
  }

  deleteConfiguration(workspaces: CtWorkspaceDto): Observable<boolean> {
    return this.httpCacheClient
      .delete(`${this._entityUrl}/`, undefined, undefined, undefined, workspaces)
      .pipe(map(() => true));
  }
}
